<template>
  <div class="il-refinance-resend-button">
    <RiseupButton
      :title="buttonText"
      :disabled="isDisabled"
      :action="onResendClick"
      :size="'large'"
      :variant="'secondary'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';
import LoginApi from '@/api/LoginApi';
import anonymousSession from '@/anonymousSession';

export default {
  name: 'IlReFinanceResendButton',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      isResending: false,
      cooldownSeconds: 0,
      cooldownInterval: null,
    };
  },
  mounted() {
    if (this.phoneNumber) {
      this.startCooldown();
    }
  },
  beforeDestroy() {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
  },
  watch: {
    phoneNumber(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.startCooldown();
      }
    },
  },
  computed: {
    ...mapState('signup', ['phoneNumber']),
    isDisabled() {
      return this.isResending || this.cooldownSeconds > 0;
    },
    buttonText() {
      if (this.isResending) {
        return 'שולח...';
      }
      if (this.cooldownSeconds > 0) {
        return `ניתן לשלוח שוב בעוד ${this.cooldownSeconds} שניות`;
      }
      return 'לא קיבלתי, שלחו לי שוב';
    },
    phoneLast4Digits() {
      return this.phoneNumber?.slice(-4);
    },
  },
  methods: {
    startCooldown() {
      if (this.cooldownInterval) {
        clearInterval(this.cooldownInterval);
      }
      this.cooldownSeconds = 10;
      this.cooldownInterval = setInterval(() => {
        this.cooldownSeconds -= 1;
        if (this.cooldownSeconds <= 0) {
          clearInterval(this.cooldownInterval);
          this.cooldownInterval = null;
        }
      }, 1000);
    },
    async onResendClick() {
      const anonId = anonymousSession.getId();
      if (!this.phoneNumber || this.isDisabled) {
        return;
      }
      Segment.trackUserInteraction('buttonClicked', { buttonText: this.buttonText });
      this.isResending = true;

      try {
        await LoginApi.sendReFinanceLink(this.phoneNumber, anonId);
        Segment.trackUserInteraction('ReFinanceSignup_LinkResent', { phoneLast4Digits: this.phoneLast4Digits });
        this.startCooldown();
      } catch (e) {
        Segment.trackUserInteraction(
          'ReFinanceSignup_ResendFailed',
          { phoneLast4Digits: this.phoneLast4Digits, error: e.message },
        );
      } finally {
        this.isResending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.il-refinance-resend-button {
  width: 100%;
  padding: 16px;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep .riseup-button {
    width: 345px;
  }
}
</style>
